// Recovered compiled webpack factory 32319. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  (a.d(t, { PA: () => i, nw: () => n }), a(95704));
  let r = [
    {
      id: "price_1TQxDrIdJGMX42b0VzSQnG2N",
      generation: 1,
      cadence: "monthly",
      amountCents: 800,
      mode: "live",
    },
    {
      id: "price_1TQxDrIdJGMX42b0aovLIGGE",
      generation: 1,
      cadence: "yearly",
      amountCents: 7200,
      mode: "live",
    },
    {
      id: "price_1TQxOkIiFrTOTqij88qtLg1g",
      generation: 1,
      cadence: "monthly",
      amountCents: 800,
      mode: "test",
    },
    {
      id: "price_1TQxOkIiFrTOTqijs4M7UYdB",
      generation: 1,
      cadence: "yearly",
      amountCents: 7200,
      mode: "test",
    },
    {
      id: "price_1TlG2EIdJGMX42b0GXTgaV7y",
      generation: 2,
      cadence: "monthly",
      amountCents: 1200,
      mode: "live",
    },
    {
      id: "price_1TlG2pIdJGMX42b0Rbls2efS",
      generation: 2,
      cadence: "yearly",
      amountCents: 9600,
      mode: "live",
    },
    {
      id: "price_1TlG8aIiFrTOTqij9kF8hLTK",
      generation: 2,
      cadence: "monthly",
      amountCents: 1200,
      mode: "test",
    },
    {
      id: "price_1TlG8qIiFrTOTqijC7fy8x55",
      generation: 2,
      cadence: "yearly",
      amountCents: 9600,
      mode: "test",
    },
    {
      id: "price_1UK2KNIdJGMX42b0RViJBGdZ",
      generation: 3,
      cadence: "monthly",
      amountCents: 2e3,
      mode: "live",
    },
    {
      id: "price_1UK2L0IdJGMX42b0ya4ZOnIL",
      generation: 3,
      cadence: "yearly",
      amountCents: 12e3,
      mode: "live",
    },
    {
      id: "price_1UK2MGIiFrTOTqijdMRpfQPX",
      generation: 3,
      cadence: "monthly",
      amountCents: 2e3,
      mode: "test",
    },
    {
      id: "price_1UK2MaIiFrTOTqij3fwYBwVy",
      generation: 3,
      cadence: "yearly",
      amountCents: 12e3,
      mode: "test",
    },
  ];
  function n(e, t) {
    let a = r.find((a) => 3 === a.generation && a.cadence === e && a.mode === t);
    if (!a) throw Error(`No current ${t} Price for ${e}`);
    return a;
  }
  function i(e) {
    var t;
    return `${((t = e.amountCents), `$${(t / 100).toFixed(2)}`).replace(/\.00$/, "")}/${"yearly" === e.cadence ? "yr" : "mo"}`;
  }
  r.map((e) => [e.id, e]);
}
